import React from 'react'
import { NavLink } from 'react-router-dom'
import { useCheckout } from 'lib/modules/checkout'
import { Container } from './styled'

export const Nav = () => {
  const { validateShippingAddress, validateShippingMethod, requiresShipping } = useCheckout()
  const isSchemaValid = validateShippingAddress() && validateShippingMethod()

  if (!requiresShipping()) {
    return null
  }

  return (
    <Container>
      <ul>
        <li>
          <NavLink
            to='/checkout/shipping'
          >
            Step 1: Shipping Information
          </NavLink>
        </li>
        <li
          className={isSchemaValid ? '' : 'disabled'}
        >
          <NavLink
            to='/checkout/billing'
          >
            Step 2: Payment & Billing Info
          </NavLink>
        </li>
      </ul>
    </Container>
  )
}
